module.exports = __webpack_public_path__ + "static/media/photos_6.7f3015df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos_6.jpg
// module id = 97
// module chunks = 0